export enum CheckoutRouteNameEnum {
	main = "checkout",
	success = "checkout.success",
	error = "checkout.error",
	stripeAccount = "stripe.account",
	contract = "contract",
}
